/**
 * @module SelectPurchaseOrder
 */

import axios from 'api/axios'

class SelectPurchaseOrder {
  /**
   * Toggle User Line Selection
   * @async
   * @param {string} id
   */
  static async toggleOrderLine(id) {
    try {
      await axios.get(`efactura/purchaseorder/user_line_selection/${id}/`)
    } catch (error) {
      throw new Error(`Error modificando el estado de selección de la línea de pedido`)
    }
  }

  /**
   * Toggle User Order Selection
   * @async
   * @param {string} id
   */
  static async toggleOrder(id) {
    try {
      await axios.get(`efactura/purchaseorder/user_order_selection/${id}/`)
    } catch (error) {
      throw new Error(`Error modificando el estado de selección de pedido`)
    }
  }
}

export default SelectPurchaseOrder
